import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { UserCreatePayload } from '../models/user-create-model';
import { CustomerCreateModel } from '../models/customer-create-model';

@Injectable({
  providedIn: 'root',
})
export class CustomerMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetCustomerList() {
    return this.http.get(`${environment.ROOT_URL}/customer`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveCustomer(payload: CustomerCreateModel) {
    return this.http.post(
      `${environment.ROOT_URL}/customer`,
      payload,  
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }

  lFN_GetCustomerById(customerId: number) {
    return this.http.get(`${environment.ROOT_URL}/customer/customer-id/${customerId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

}
